import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
  View,
} from 'react-native';
import {
  Button,
  Input,
  Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Header from '../../misc/Header';

import { language } from '../../../localization';
import { translate } from '../../../locales/i18n';
import AORTypes from '../../../types';
import styles from '../../../styles';
import { userNameValidation, userDescValidation } from '../../../modules/validation/User';
import MyPublisherBadge from '../../apps/MyPublisherBadge';
import Publisher from '../../../modules/data/Publisher';

const validationSchema = yupObject().shape({
  name: userNameValidation,
  desc: userDescValidation,
});

class ProfileForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  handleApply = async (values, formikBag) => {
    const { onApply } = this.props;

    formikBag.setSubmitting(true);
    this.setState({ error: undefined });

    const err = await onApply(values);
    if (err !== null) {
      formikBag.setStatus(err);
      this.setState({ error: err });
    }
    formikBag.setSubmitting(false);
  };

  handleSignOut = (_values, _formikBag) => {
    const { onSignOut } = this.props;

    onSignOut();
  };

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    // status,
  }) => {
    const {
      user,
      onAddUserImage,
      updateUserData,
      getUploader,
      // onCancel,
    } = this.props;
    const { error } = this.state;
    const { history } = this.props;
    const { publisher } = values;

    // if (!values.name) {
    //   return (
    //     <>
    //     </>
    //   );
    // }

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            backgroundColor: 'white',
            width: '100%',
            padding: 0,
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        ]}
        behavior="padding"
      // the dismiss ones below may the keyboard jump up and down on an attempt to move the cursor
      // onPress={Keyboard.dismiss}
      // onTouchStart={Keyboard.dismiss}
      >
        <Header
          name={values.email}
          hasBack
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            maxWidth: 600,
            alignSelf: 'center',
            margin: 0,
          }}
          contentContainerStyle={{
            width: '100%',
            padding: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
            paddingBottom: 20,
          }}
        >
          <View
            style={{
              width: '80%',
              margin: 10,
            }}
          >
            <View
              style={{
                minHeight: 80,
                maxWidth: 500,
              }}
            >
              <MyPublisherBadge
                user={user}
                userData={publisher.data}
                publisher={publisher}
                onAddUserImage={onAddUserImage}
                updateUserData={updateUserData}
                getUploader={getUploader}
              />
            </View>
          </View>
          <View
            style={{
              flex: 1,
              justifyContent: 'space-evenly',
              alignItems: 'center',
              width: '100%',
              paddingHorizontal: 10,
            }}
          >
            {error !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {error}
              </Text>
            )}
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.name && errors.name ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              // leftIconContainerStyle={styles.form.inputIconContainer}
              label={translate('profile_username')}
              value={values.name || ''}
              placeholder={translate('profile_username_placeholder')}
              autoCompleteType="name"
              textContentType="name"
              // leftIcon={(
              //   <Icon
              //     name="face"
              //     size={24}
              //     color="black"
              //   />
              // )}
              keyboardType="default"
              autoCapitalize="none"
              onChangeText={(value) => { setFieldValue('name', value); publisher.data.name = value; }}
              onBlur={() => setFieldTouched('name')}
              editable={!isSubmitting}
              errorMessage={touched.name && errors.name ? errors.name : undefined}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={[styles.form.inputInput, { marginVertical: 15 }]}
              inputContainerStyle={touched.desc && errors.desc ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              // leftIconContainerStyle={styles.form.inputIconContainer}
              style={{
                textAlignVertical: 'top',
              }}
              label={translate('profile_description')}
              value={values.desc || ''}
              placeholder={translate('profile_description_placeholder')}
              // leftIcon={(
              //   <Icon
              //     name="face"
              //     size={24}
              //     color="black"
              //   />
              // )}
              keyboardType="default"
              autoCapitalize="none"
              multiline
              numberOfLines={3}
              scrollEnabled
              onChangeText={(value) => {
                setFieldValue('desc', value);
                publisher.pp.desc[language()] = value;
                publisher.data.desc = JSON.stringify(publisher.pp.desc);
              }}
              onBlur={() => setFieldTouched('desc')}
              editable={!isSubmitting}
              errorMessage={touched.desc && errors.desc ? errors.desc : undefined}
            />
            {/* <Input
              containerStyle={{
                ...(Platform.OS === 'web' ? ({
                  width: '80%',
                }) : ({
                  width: '100%',
                })),
              }}
              label={translate('profile_email')}
              value={values.email}
              placeholder={translate('signin_email')}
              // autoCompleteType="email"
              textContentType="emailAddress"
              // leftIcon={(
              //   <Icon
              //     name="face"
              //     size={24}
              //     color="black"
              //   />
              // )}
              editable={false}
              keyboardType="email-address"
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('email', value)}
              onBlur={() => setFieldTouched('email')}
              errorMessage={touched.email && errors.email ? errors.email : undefined}
              disabled
            /> */}
            <Button
              title={translate('button_save')}
              containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
              buttonStyle={styles.buttonfsf.primary}
              disabledStyle={styles.buttonfsf.primaryDisabled}
              titleStyle={styles.buttonfsf.primaryTitle}
              disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
              onPress={handleSubmit}
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
            <Button
              clear
              title={translate('profile_signout')}
              containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
              buttonStyle={styles.buttonfsf.secondary}
              titleStyle={styles.buttonfsf.secondaryTitle}
              onPress={() => this.handleSignOut()}
            />
            {/* <Button
              clear
              title={translate('button_back')}
              containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
              buttonStyle={styles.buttonfsf.secondary}
              titleStyle={styles.buttonfsf.secondaryTitle}
              onPress={() => onCancel()}
            /> */}
          </View>
        </KeyboardAwareScrollView>
      </KeyboardAvoidingView>
    );
  }

  render() {
    const { user, userData } = this.props;

    // console.log('user');
    // console.log(user);
    // console.log('userData');
    // console.log(userData);
    if (!user || !user.attributes || !userData || !userData.uuid) {
      console.log('not ready');
      return (
        <>
        </>
      );
    }

    const publisher = Publisher.createFromData(userData);
    publisher.postProcess();

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={{
          publisher,
          name: publisher.data.name,
          desc: publisher.pp.desc[language()] || '',
          email: user.attributes.email,
        }}
        onSubmit={this.handleApply}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

ProfileForm.propTypes = {
  user: AORTypes.AWS.Cognito.User.isRequired,
  userData: AORTypes.User.isRequired,
  onApply: PropTypes.func.isRequired,
  // onCancel: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  onAddUserImage: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default ProfileForm;
